import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { TABLE_DEFINITION, VaFilteredMatTableService, VaTableSortService } from '@vendasta/va-filter2-table';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AddToCampaignDialogComponent } from '../actions/add-to-campaign-dialog.component';
import { UserList } from './user-list';
import { tableDefinitionFactory, UserListsDetails } from './user-lists-details-table-model';
import { UserListsDetailsService } from './user-lists-details.service';

@Component({
  templateUrl: './user-lists-details.component.html',
  styleUrls: ['./user-lists-details.component.scss'],
  providers: [
    VaFilteredMatTableService,
    VaTableSortService,
    UserListsDetailsService,
    {
      provide: TABLE_DEFINITION,
      useFactory: tableDefinitionFactory,
    },
  ],
})
export class UserListsDetailsComponent implements OnInit, OnDestroy {
  userList: UserList;
  subscriptions: Subscription[] = [];

  constructor(
    readonly vaFilteredMatTableService: VaFilteredMatTableService<UserListsDetails>,
    readonly userListsDetailsService: UserListsDetailsService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.params.pipe(tap((params) => this.userListsDetailsService.setUserList(params.listId))).subscribe(),
    );
    this.subscriptions.push(
      this.userListsDetailsService.userList$
        .pipe(
          tap((ul) => {
            this.userList = ul;
          }),
        )
        .subscribe(),
    );

    this.subscriptions.push(
      this.userListsDetailsService.reload$.subscribe(() => this.vaFilteredMatTableService.resetPaging()),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  onAddToCampaignPressed(): void {
    if (!this.userList) {
      return;
    }

    const dialogRef = this.dialog.open(AddToCampaignDialogComponent, {
      width: '660px',
    });
    dialogRef.componentInstance.userList = this.userList;
    dialogRef.afterClosed().subscribe({
      error: () => {
        this.snackbarService.openWithOptions('LISTS.CAMPAIGN_DIALOG.CAMPAIGN_AVOIDED', {
          interpolateTranslateParams: {
            name: this.userList.userListName,
          },
        });
      },
    });
  }
}
